import Vue from "vue";

Vue.filter("ucase" , function(val){
  return val.toUpperCase();
})
Vue.filter("reverse",function(val){
  return val.split("").reverse("").join("");
})
Vue.filter("shorten",function(val,l,suffix){
  return val.substring(0,l )+ suffix;

})


import moment from 'moment'
Vue.filter('formatDateForMySQL', function (date) {
  if (!date) return ''; // Handle empty or null input
  const pad = (num) => String(num).padStart(2, '0'); // Helper for padding
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // Months are zero-based
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
});

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY HH:mm')
  }
})
//
Date.prototype.addHours= function(h){
  var copiedDate = new Date(this.getTime());
  copiedDate.setHours(copiedDate.getHours()+h);
  return copiedDate;
}
//
const tz1 = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Africa/Cairo', // Replace this with your desired time zone
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
}).format(new Date());
//
Vue.filter('formatDate2', function(value) {
  if (value) {
   // var foo = new moment(value).add(-2, 'h').toDate();  // add -2 hours to readjust time
    return moment(String(value)).format(tz1)
  }
})
//
Vue.filter('formatDateminus2h', function(value) {
  if (value) {
    var foo = new moment(value).add(-2, 'h').toDate();  // add -2 hours to readjust time
    return moment(String(foo)).format('DD MMMM-YYYY HH:mm')
  }
})
//
Vue.filter('formatDateonly', function(value) {
  if (value) {
   // var foo = new moment(value).add(-2, 'h').toDate();  // add -2 hours to readjust time
    return moment(String(value)).format('DD MMMM-YYYY')
  }
})
Vue.filter('formatDateonly2', function(value) {
  if (value) {
   // var foo = new moment(value).add(-2, 'h').toDate();  // add -2 hours to readjust time
    return moment(String(value)).format('DD MMMM-YYYY HH:mm')
  }
})
//
var numeral = require("numeral");
Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0.00"); // displaying other groupings/separators is possible, look at the docs
});
// Vue.filter('formatNumber', function (value) {
//   if (value){
//     return numeral(value).format('0,0000') // displaying other groupings/separators is possible, look at the docs

//   }
// })

Vue.filter('formatDateOnly', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD')
  }
})

//

Vue.filter('monthName', function(value) {
  var  months =["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  if (value) {
    return months.at(value-1)
  }
})
